import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ButtonList, ButtonSize, ButtonVariant, CurrencyItem, IconColor, IconName, IconSize, Image, Popover, PopoverPosition, usePopoverHandlers, } from '@as/cotopaxi';
import { Box, Breakpoint } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { MenuUtil } from '../../util/MenuUtil';
const CurrencyMenuItem = ({ currencies, isDesktop }) => {
    const { t } = useTranslation(I18N_NAMESPACES.navigation);
    const { anchorEl, handlePopoverOpen, handlePopoverClose } = usePopoverHandlers();
    const currentCurrency = currencies.find(curr => curr.active === true) || currencies[0];
    const closeAll = () => {
        MenuUtil.close();
        handlePopoverClose();
    };
    if (!currentCurrency)
        return null;
    const currencyButton = (currency, active) => ({
        active,
        key: currency.name,
        href: currency.homepage,
        text: _jsx(CurrencyItem, { name: currency.name, flag: currency.flag, currency: currency.currency }),
    });
    const getCurrencyButtonList = currencies.reduce((acc, currency) => {
        if (currentCurrency.name !== currency.name) {
            acc.push(currencyButton(currency, false));
        }
        return acc;
    }, [currencyButton(currentCurrency, true)]);
    return (_jsxs(_Fragment, { children: [isDesktop ? (_jsx(Breakpoint, { from: "lg", children: _jsx(Box, { paddingInlineEnd: "6", children: _jsx(Button, { variant: ButtonVariant.LINK_SUBTLE, size: ButtonSize.SMALL, iconRight: {
                            name: anchorEl ? IconName.CHEVRON_UP : IconName.CHEVRON_DOWN,
                            color: IconColor.ACTION,
                            size: IconSize.MINOR,
                        }, onClick: handlePopoverOpen, text: _jsx(Image, { src: currentCurrency.flag }) }) }) })) : (_jsx(Breakpoint, { until: "lg", children: _jsx(ButtonList, { buttons: [
                        {
                            text: _jsx(CurrencyItem, { name: currentCurrency.name, flag: currentCurrency.flag }),
                            iconRight: {
                                name: IconName.CHEVRON_RIGHT,
                                color: IconColor.ACTION,
                            },
                            onClick: handlePopoverOpen,
                            noBubble: true,
                        },
                    ] }) })), _jsx(Popover, { analyticsAreaName: "header-internationalisation", noPadding: true, anchorEl: anchorEl, onClose: handlePopoverClose, position: PopoverPosition.BOTTOM_LEFT, showTitleOnDesktop: false, title: t('flyout.bottom.currency'), leftElement: _jsx(Button, { variant: ButtonVariant.TRANSPARENT, onClick: handlePopoverClose, icon: {
                        name: IconName.ARROW_LEFT,
                        color: IconColor.ACTION,
                        size: IconSize.MAJOR,
                    } }), rightElement: _jsx(Button, { variant: ButtonVariant.TRANSPARENT, onClick: closeAll, icon: {
                        name: IconName.CLOSE,
                        color: IconColor.ACTION,
                        size: IconSize.MAJOR,
                    } }), children: _jsx(ButtonList, { buttons: getCurrencyButtonList }) })] }));
};
export default CurrencyMenuItem;
